import { createAppState } from '../appState';
import { initClsDebug } from '../clsDebug';
import { renderApp } from '../renderApp';

export function runApp() {
  const store = createAppState();

  renderApp(store);

  /* Временная диагностика CLS. Удалить вместе с services/clsDebug, когда причина найдена. */
  const state = store.getState();

  initClsDebug({
    isAuthenticated: Boolean(state.user?.isAuthenticated),
    abGroup: state.pageData?.abGroup ?? null,
  });
}
